import React from 'react';
import { Send } from 'lucide-react';

const FIELD_CLS = 'w-full px-4 py-3 border border-neutral-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-neutral-500 bg-sand-50';

const INTERESTS = [
  ['general', 'General Inquiry'],
  ['buying', 'Buying a Home'],
  ['selling', 'Selling a Home'],
  ['valuation', 'Home Valuation'],
  ['consultation', 'Schedule Consultation'],
];

const submitLabel = (submitted, submitting) => {
  if (submitted) return '✓ Message Sent!';
  return submitting ? 'Sending…' : 'Send Message';
};

export const ContactForm = ({ form, setForm, onSubmit, submitted, submitting, openPrivacyPolicy }) => {
  const onChange = (key) => (e) => setForm({ ...form, [key]: e.target.value });
  return (
    <div className="bg-gradient-to-br from-sand-100 to-neutral-50 rounded-2xl p-8 border border-neutral-200">
      <form onSubmit={onSubmit} className="space-y-6" data-testid="contact-form">
        <div>
          <label className="block text-sm font-medium text-neutral-700 mb-2">I'm interested in:</label>
          <select data-testid="contact-interest" className={FIELD_CLS} value={form.interest} onChange={onChange('interest')}>
            {INTERESTS.map(([value, label]) => <option key={value} value={value}>{label}</option>)}
          </select>
        </div>
        <div className="grid sm:grid-cols-2 gap-4">
          <input data-testid="contact-name" aria-label="Your name" autoComplete="name" className={FIELD_CLS} placeholder="Your Name*" required value={form.name} onChange={onChange('name')} />
          <input data-testid="contact-phone" type="tel" aria-label="Phone number" autoComplete="tel" className={FIELD_CLS} placeholder="Phone Number*" required value={form.phone} onChange={onChange('phone')} />
        </div>
        <input data-testid="contact-email" type="email" aria-label="Email address" autoComplete="email" className={FIELD_CLS} placeholder="Email Address*" required value={form.email} onChange={onChange('email')} />
        <textarea data-testid="contact-message" aria-label="Your message" className={`${FIELD_CLS} resize-none`} placeholder="Tell me about your real estate needs...*" required rows={5} value={form.message} onChange={onChange('message')}></textarea>
        <div className="flex items-start space-x-3 bg-sand-50 p-4 rounded-lg border border-amber-200">
          <input type="checkbox" id="contactSmsConsent" className="mt-1 w-4 h-4" checked={form.smsConsent} onChange={(e) => setForm({ ...form, smsConsent: e.target.checked })} />
          <label htmlFor="contactSmsConsent" className="text-xs text-neutral-700 leading-relaxed">I agree to be contacted by Jess Sells East Coast via call, email, and text for real estate services. To opt-out, you can reply 'STOP' at any time or reply 'HELP' for assistance. Message and data rates may apply. Message frequency may vary. <button type="button" onClick={openPrivacyPolicy} className="text-[#143160] underline font-semibold hover:text-gold-600">Privacy Policy</button>.</label>
        </div>
        <button data-testid="contact-submit" type="submit" disabled={submitting} className="w-full bg-neutral-800 hover:bg-neutral-900 text-white py-3 rounded-md font-medium flex items-center justify-center group disabled:opacity-70 disabled:cursor-wait">
          {submitLabel(submitted, submitting)}<Send className="w-4 h-4 ml-2 group-hover:translate-x-1 transition-transform" />
        </button>
        <p className="text-xs text-center text-neutral-500">Your privacy is protected. We never share your information.</p>
      </form>
    </div>
  );
};
